const defaultHomepageEditorConfig = {
  initialContent: {
    title: "",
    headline: "",
    about: "",
    registration_label: "Register",
    registration_url: "",
    meta_sport: "",
    meta_location: "",
    cover_url: "",
  },

imageFields: {
  cover: {
    contentKey: "cover_url",
  },
},

  loadContent(content = {}) {
    return {
      ...this.initialContent,
      ...content,
    };
  },

  buildContent(templateState = {}, sharedState = {}) {
    return {
      title: templateState.title?.trim() || "",
      headline: templateState.headline?.trim() || "",
      about: templateState.about?.trim() || "",
      registration_label:
        templateState.registration_label?.trim() || "Register",
      registration_url: templateState.registration_url?.trim() || "",
      meta_sport: templateState.meta_sport?.trim() || "",
      meta_location: templateState.meta_location?.trim() || "",
cover_url:
  sharedState.resolvedImageUrls?.cover || "",
    };
  },

getStep2Props({
  templateState,
  setTemplateField,
  getImageField,
  setImageFile,
  setImageRemoved,
}) {
const cover = getImageField("cover");

  return {
    templateState,
    setTemplateField,

    coverFile: cover.file,
setCoverFile: (file) => setImageFile("cover", file),

    existingCoverUrl: cover.existingUrl,

    removeCover: cover.remove,
setRemoveCover: (remove) => setImageRemoved("cover", remove),
  };
},
};

export default defaultHomepageEditorConfig;